import MainRoutes from "./Routes";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Loader from "./components/common/Loader";
import { useLoader } from "./context/loader";
import ScrollToTop from "./components/atom/ScrollToTop";
import { useEffect } from "react";
import { useParams, Outlet, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useQuery } from "@apollo/client";
import { GET_LANGUAGES } from "api/graphql/Settings";

const LanguageRouter = () => {
  const { locale } = useParams();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { data } = useQuery(GET_LANGUAGES);

  useEffect(() => {
    const languageChangedEventHandler = (newLocale) => {
      navigate(`/${newLocale}`, { replace: true });
    };

    i18n.on("languageChanged", languageChangedEventHandler);

    return () => {
      i18n.off("languageChanged", languageChangedEventHandler);
    };
  }, []);

  useEffect(() => {
    if (
      !locale ||
      (data?.language?.length && !data?.language?.includes(locale))
    ) {
      navigate(`/${i18n.language}`, { replace: true });
      return;
    }

    if (i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
  }, [locale]);

  return <Outlet />;
};

function App() {
  const { loading } = useLoader();

  return (
    <>
      {loading && <Loader />}
      <Routes>
        <Route path="/:locale?" element={<LanguageRouter />}>
          {MainRoutes}
        </Route>
      </Routes>
    </>
  );
}

function AppWithRouter() {
  return (
    <Router>
      <ScrollToTop />
      <App />
    </Router>
  );
}

export default AppWithRouter;
